<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('api.account.account') }}
                <template v-if="isLoaded && account.name"> - {{ account.name }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        :to="{ name: 'apis.accounts.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('api.account.accountsList') }}</span>
                        <span class="hidden-xs">{{ $t('api.account.accountsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-if="isLoaded && !is404"
                        :to="{
                            name: 'apis.accounts.edit',
                            params: { id: accountId },
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('edit') }}</span>
                        <span class="hidden-xs">{{ $t('edit') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-edit"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body with-border clearfix"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <template v-else>
                            <div
                                v-if="is404 || !account.id"
                                class="box-body with-border clearfix"
                            >
                                <div class="row">
                                    <div class="col-xs-12">
                                        <p>
                                            {{ $t('messages.api.account.noAccount', { id: accountId }) }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <template v-else>
                                <div class="box-header with-border">
                                    <h3 class="box-title">{{ $t('info') }}</h3>
                                </div>

                                <div class="box-body">
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('name') }}:</strong>
                                            <p>{{ account.name }}</p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('sendingRate') }}:</strong>
                                            <p>{{ account.sendingRate }}</p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('createdAt') }}:</strong>
                                            <p>
                                                {{ formatDate(account.createdAt) }}
                                            </p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('updatedAt') }}:</strong>
                                            <p>
                                                {{ formatDate(account.updatedAt) }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong> {{ $t('senderIp.senderIp') }}: </strong>
                                            <p>
                                                <ValueEmpty :value="account.senderIp ? account.senderIp.name : null" />
                                            </p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong> {{ $t('provider.provider') }}: </strong>

                                            <p>
                                                <ValueListEmpty
                                                    :list="[account.provider]"
                                                    block
                                                    href="/apis/providers/"
                                                />
                                            </p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-6">
                                            <strong> {{ $t('api.apis') }}: </strong>

                                            <p>
                                                <ValueListEmpty
                                                    :list="account.apis"
                                                    block
                                                    href="/apis/"
                                                />
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row"></div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import EventBus from '@/event-bus';
import ValueListEmpty from '@/components/subcomponents/ValueListEmpty';
import formatsMixin from '@/mixins/formatsMixin';
import ValueEmpty from "../../../components/subcomponents/ValueEmpty.vue";

export default {
    components: {
        ValueEmpty,
        ValueListEmpty,
    },

    mixins: [formatsMixin],

    data() {
        return {
            is404: false,
            isLoaded: false,
            accountId: this.$route.params.id,
            account: {},
        };
    },

    computed: {
        headTitle() {
            return this.account.name && `${this.$t('api.account.account')} ${this.account.name}`;
        },
    },

    created() {
        this.fetchApiAccount();
    },

    methods: {
        async fetchApiAccount() {
            try {
                const {
                    data: { account },
                } = await axios.get('/apis/accounts/data/account', {
                    params: {
                        id: this.accountId,
                    },
                });

                this.account = account;
            } catch (error) {
                this.is404 = error.response.status === 404;

                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoaded = true;
            }
        },
    },
};
</script>
